/* eslint-disable id-length */

import { mixpanel, traffic2 } from '../../utils/buildAnalyticsEvents';

export const DASHBOARD_EVENTS = {
  SCHEDULED_CAMPAIGNS_LINK_CLICK: {
    ...mixpanel('GUM Scheduled Campaigns Tab Click'),
    ...traffic2('marketing.scheduled_campaigns.link.click')
  },
  AUTO_CAMPAIGNS_LINK_CLICK: {
    ...mixpanel('GUM Auto Campaigns Tab Click'),
    ...traffic2('marketing.auto_campaigns.tab.click')
  },
  ALL_CAMPAIGNS_LINK_CLICK: {
    ...mixpanel('GUM All Campaigns Tab Click'),
    ...traffic2('marketing.all_campaigns.tab.click')
  },
  DRAFT_CAMPAIGNS_LINK_CLICK: {
    ...mixpanel('GUM Draft Campaigns Tab Click'),
    ...traffic2('marketing.draft_campaigns.tab.click')
  },
  PREPARING_LINK_CLICK: {
    ...mixpanel('GUM Preparing Campaigns Tab Click'),
    ...traffic2('marketing.preparing_campaigns.tab.click')
  },
  SENT_CAMPAIGNS_LINK_CLICK: {
    ...mixpanel('GUM Sent Campaigns Tab Click'),
    ...traffic2('marketing.sent_campaigns.tab.click')
  },
  DASHBOARD_MAILING_CREDITS_MESSAGE_CLOSE_CLICKED: {
    ...mixpanel('GUM Dashboard Mailing Credits Message Close Clicked'),
    ...traffic2('marketing.dashboard.mailing_credits_message_close.click')
  },
  NEW_CAMPAIGN_PAGE_VISITED: {
    ...mixpanel('GUM New Campaign Visited'),
    ...traffic2('marketing.new.campaign.impression')
  },
  SUGGESTION_CLICKED: {
    ...mixpanel('GUM Suggestion Clicked'),
    ...traffic2('marketing.suggestion.click')
  },
  SUGGESTIONS_SEE_ALL_CLICKED: {
    ...mixpanel('GUM Suggestions See All Clicked'),
    ...traffic2('marketing.see_all_suggestions.click')
  },
  LATEST_CAMPAIGN_CLICKED: {
    ...mixpanel('GUM Latest Campaign Clicked'),
    ...traffic2('marketing.latest_campaign.click')
  },
  CREATE_NEW_EMAIL_CLICK: {
    ...mixpanel('GUM Create New Email Click'),
    ...traffic2('marketing.new_email.click')
  },
  DOWNLOAD_CSV_CLICKED: {
    ...mixpanel('GUM Download CSV clicked'),
    ...traffic2('marketing.download_csv.click')
  },
  RESCHEDULE_EMAIL: {
    ...mixpanel('GUM Reschedule Email'),
    ...traffic2('marketing.reschedule_email.click')
  },
  DELETE_EMAIL: {
    ...mixpanel('GUM Delete Email'),
    ...traffic2('marketing.delete_email.click')
  },
  CLONE_EMAIL: {
    ...mixpanel('GUM Clone Email'),
    ...traffic2('marketing.clone_email.click')
  },
  EDIT_EMAIL: {
    ...mixpanel('GUM Edit Email'),
    ...traffic2('marketing.edit_mail.click')
  },
  CAMPAIGNS_TEXT_SEARCH: {
    ...mixpanel('GUM Search Term'),
    ...traffic2('marketing.search.click')
  },
  CAMPAIGNS_SEARCH_CLEAR_INPUT_CLICKED: {
    ...mixpanel('GUM Clear Search Input'),
    ...traffic2('marketing.search.input.clear.click')
  },
  CAMPAIGNS_SORT_CLICKED: {
    ...mixpanel('GUM Sort Order change'),
    ...traffic2('marketing.sort.click')
  },
  CAMPAIGNS_SEARCH_CLEAR_BUTTON_CLICKED: {
    ...mixpanel('GUM Clear Search Results'),
    ...traffic2('marketing.button.clear.click')
  },
  CAMPAIGNS_CREATE_EMPTY_BUTTON_CLICKED: {
    ...mixpanel('GUM Zero State Create Email Click'),
    ...traffic2('marketing.empty.button.clear.click')
  },
  STATS_CLICKED: {
    ...mixpanel('GUM Stats Link Clicked'),
    ...traffic2('marketing.stats_email.click')
  },
  SEND_EMAIL: {
    ...mixpanel('GUM Send Link Clicked'),
    ...traffic2('marketing.send_email.click')
  },
  UNSCHEDULE_EMAIL: {
    ...mixpanel('GUM Unschedule Link Clicked'),
    ...traffic2('marketing.unschedule_email.click')
  },
  SHARE_EMAIL: {
    ...mixpanel('GUM Share Link Clicked'),
    ...traffic2('marketing.share_email.click')
  },
  VIEW_IN_BROWSER_EMAIL: {
    ...mixpanel('GUM View In Browser Link Clicked'),
    ...traffic2('marketing.view_in_browser_email.click')
  },
  SHELF_TEMPLATE_CLICKED: {
    ...mixpanel('GUM Shelf Template Clicked'),
    ...traffic2('marketing.shelf.template.click')
  },
  TOP_CAMPAIGN_CLICKED: {
    ...mixpanel('GUM Top Campaign Clicked'),
    ...traffic2('marketing.top.campaign.click')
  },
  DELETE_MODAL_CAMPAIGN_DELETE_BUTTON_CLICKED: {
    ...mixpanel('GUM Delete Modal Campaign Delete Button Clicked'),
    ...traffic2('marketing.delete_modal_campaign_delete.button.click')
  },
  DELETE_MODAL_CAMPAIGN_CLOSE_MODAL_CLICKED: {
    ...mixpanel('GUM Delete Modal Campaign Close Clicked'),
    ...traffic2('marketing.delete_modal_campaign_close_modal.click')
  },
  UNSCHEDULE_MODAL_CAMPAIGN_UNSCHEDULE_BUTTON_CLICKED: {
    ...mixpanel('GUM Unschedule Modal Campaign Unschedule Button Clicked'),
    ...traffic2('marketing.unschedule_modal_campaign_unschedule.button.click')
  },
  UNSCHEDULE_MODAL_CAMPAIGN_CLOSE_MODAL_CLICKED: {
    ...mixpanel('GUM Unschedule Modal Campaign Close Clicked'),
    ...traffic2('marketing.delete_modal_campaign_close_modal.click')
  },
  REVIEW_SERVICE_REQUEST_CLICK: {
    ...mixpanel('GUM Review Button Click'),
    ...traffic2('marketing.service_request_review.button.click')
  },
  MARKETING_HEADER_IMPRESSION: {
    ...mixpanel('Marketing Header Impression'),
    ...traffic2('marketing_overview.header.tab.impression')
  },
  MARKETING_HEADER_CHANGE_TAB: {
    ...mixpanel('Marketing Header Change Tab'),
    ...traffic2('marketing_overview.header.change.tab.click')
  },
  CAMPAIGNS_TABLE_PAGE_CHANGE: {
    ...mixpanel('GUM Content Items Table Page Change'),
    ...traffic2('marketing.campaigns.page_change.impression')
  },
  CONTENT_ITEM_ERROR_BUTTON_CLICKED: {
    ...mixpanel('GUM Content Item Retry Button Clicked'),
    ...traffic2('marketing.content_item_retry.button.click')
  },
  CAMPAIGN_ERROR_BUTTON_CLICKED: {
    ...mixpanel('GUM Campaigns Retry Button Clicked'),
    ...traffic2('marketing.campaign_retry.button.click')
  },
  TEMPLATES_ERROR_BUTTON_CLICKED: {
    ...mixpanel('GUM Templates Retry Button Clicked'),
    ...traffic2('marketing.templates_retry.button.click')
  },
  DISCOVERY_PRODUCT_SELECTOR_CLICKED: {
    ...mixpanel('GUM Product Discovery CTA Clicked'),
    ...traffic2('marketing.discovery.product_selector_button.click')
  },
  GO_TO_AUTOMATIONS: {
    ...mixpanel('GUM Go to Automations Clicked'),
    ...traffic2('marketing.header.go_to_automations.click')
  },
  DISCOVERY_AI_SUBJECT_CLICKED: {
    ...mixpanel('GUM AI Subject CTA Clicked'),
    ...traffic2('marketing.discovery.ai_subject_line_button.click')
  },
  DISCOVERY_CLICKED: {
    ...mixpanel('GUM Discovery CTA Clicked'),
    ...traffic2('marketing.discovery.button.click')
  },
  LATEST_CAMPAIGN_ERROR_RETRY: {
    ...mixpanel('GUM Latest Campaign Error Retry Click'),
    ...traffic2('marketing.latest_campaign_error_retry.click')
  },
  CLONE_PREVIOUS_CAMPAIGN: {
    ...mixpanel('GUM Clone Previous Campaign Click'),
    ...traffic2('marketing.clone_previous_campaign.click')
  },
  PREVIEW_DESKTOP_TAB_CLICKED: {
    ...mixpanel('Email Preview Modal Desktop Tab Click'),
    ...traffic2('marketing.preview_desktop.tab.click')
  },
  PREVIEW_MOBILE_TAB_CLICKED: {
    ...mixpanel('Email Preview Modal Mobile Tab Click'),
    ...traffic2('marketing.preview_mobile.tab.click')
  }
};
